var _path, _path2, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronDownz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9097 14.2103L7.61677 8.9174C7.22625 8.52688 6.59309 8.52688 6.20256 8.9174C5.81204 9.30793 5.81204 9.94109 6.20256 10.3316L12.2026 16.3316C12.5931 16.7221 13.2262 16.7221 13.6168 16.3316L19.6168 10.3316C20.0073 9.94109 20.0073 9.30793 19.6168 8.9174C19.2263 8.52688 18.5931 8.52688 18.2026 8.9174L12.9097 14.2103Z",
    fill: "#464646"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6367_3889",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 8,
    width: 15,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9097 14.2103L7.61677 8.9174C7.22625 8.52688 6.59309 8.52688 6.20256 8.9174C5.81204 9.30793 5.81204 9.94109 6.20256 10.3316L12.2026 16.3316C12.5931 16.7221 13.2262 16.7221 13.6168 16.3316L19.6168 10.3316C20.0073 9.94109 20.0073 9.30793 19.6168 8.9174C19.2263 8.52688 18.5931 8.52688 18.2026 8.9174L12.9097 14.2103Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6367_3889)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(24.9097 24.6245) rotate(-180)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9097,
    y: 24.6245,
    width: 24,
    height: 24,
    transform: "rotate(-180 24.9097 24.6245)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6367_3889",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9097,
    y: 24.6245,
    width: 24,
    height: 24,
    transform: "rotate(-180 24.9097 24.6245)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6367_3889)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.9097,
    y: 24.6245,
    width: 24,
    height: 24,
    transform: "rotate(-180 24.9097 24.6245)",
    fill: "#97144D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDownz);
export default __webpack_public_path__ + "static/media/icon_chevron_downz.b716397604c5afd823bac55796014b30.svg";
export { ForwardRef as ReactComponent };